var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',{staticClass:"main-title"},[_vm._v("SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Promotion report")])]),_c('v-flex',{staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"},attrs:{"xs12":"","sm6":""}},[_c('download-excel',{attrs:{"data":_vm.export_promotion_format,"fields":{
            No: 'No',
            'Promotion name': 'promotion_name',
            Discount: 'discount',
            Amount: 'amount',
            'Used/Cancel': 'used_cancel',
            'Value price(THB)': 'total_value_price',
            'Paid price(THB)': 'total_paid_price',
          },"name":'PromotionReport_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.xls'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"type":"csv","data":_vm.export_promotion_format,"fields":{
            No: 'No',
            'Promotion name': 'promotion_name',
            Discount: 'discount',
            Amount: 'amount',
            'Used/Cancel': 'used_cancel',
            'Value price(THB)': 'total_value_price',
            'Paid price(THB)': 'total_paid_price',
          },"name":'PromotionReport_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.csv'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv ")],1)],1)],1)],1)],1),_c('searchDateStartToEnd',{attrs:{"searching":_vm.searching},on:{"search":function($event){return _vm.searchList()}}}),_c('promotionReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }